import { render, staticRenderFns } from "./OrderStatusReadyForIssueIcon.vue?vue&type=template&id=220cc846&scoped=true&"
import script from "./OrderStatusReadyForIssueIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusReadyForIssueIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220cc846",
  null
  
)

export default component.exports